import {css} from '@emotion/react'
import {Button} from 'antd'
import runAsync from '@/script/runAsync.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import ListErrors from './ListErrors.jsx'

const cssButtonCheck = css({
    height: 'auto',
    fontSize: 'inherit',
    lineHeight: '1',
    padding: 0,
})

const ButtonCheck = props => {
    const map = useMapContext()

    const onClick = () => runAsync(
        () => map.syntax.check(),
        {action: '规范性检测'}
    )

    return (
        <Button
            css={cssButtonCheck}
            type="link"
            onClick={onClick}
            {...props}
        />
    )
}

const cssMessage = css({
    padding: 8,
    color: '#888',
    textAlign: 'center',
    textWrapStyle: 'balance',
})

const Message = props => {
    return (
        <div
            css={cssMessage}
            {...props}
        >
        </div>
    )
}

export default function SyntaxPane({report, ...props}) {
    if (void 0 === report) {
        return (
            <Message {...props}>
                正在取检测报告，请稍候
            </Message>
        )
    }
    else if (null === report) {
        return (
            <Message {...props}>
                未找到检测报告
                <ButtonCheck>开始检测</ButtonCheck>
            </Message>
        )
    }
    else if (0 < report.errors.length) {
        return (
            <>
                <Message {...props}>
                    [{report.startTime}] {report.message}
                    <ButtonCheck>再次检测</ButtonCheck>
                </Message>

                <ListErrors errors={report.errors} />
            </>
        )
    }
    else {
        return (
            <Message {...props}>
                [{report.startTime}] {report.message}
                <ButtonCheck>再次检测</ButtonCheck>
            </Message>
        )
    }
}
